import { render, staticRenderFns } from "./LocationKYBForm.vue?vue&type=template&id=e3e83638&"
import script from "./LocationKYBForm.vue?vue&type=script&lang=js&"
export * from "./LocationKYBForm.vue?vue&type=script&lang=js&"
import style0 from "./LocationKYBForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports